/* eslint-disable react/no-unescaped-entities */
import { Typography } from '@components/common/Typography';
import { dappStore } from '@components/store';
import React, { useState } from 'react';
import {
  AcceptButton,
  Container,
  ParagraphContainer,
  StyledCheckbox,
  TextContainer,
  StyledLink,
} from './LegalDisclaimerModal.styles';

const LegalDisclaimerModal = () => {
  const [scrolledToBottom, setScrolledToBottom] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);

  function handleTextContainerScroll(event: React.UIEvent) {
    const target = event.target as HTMLDivElement;
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      setScrolledToBottom(true);
    } else {
      setScrolledToBottom(false);
    }
  }

  function handleButtonOnClick() {
    localStorage.setItem('showLegalDisclaimer', 'false');
    dappStore.setState({ showLegalDisclaimerModal: false });
  }

  return (
    <Container>
      <TextContainer onScroll={handleTextContainerScroll}>
        <ParagraphContainer>
          <Typography type="p">
            This website is intended for people aged 18 and over. By using this website, you represent and warrant that
            you are of legal age and that you are not residing or otherwise associated with the United States of America
            (including its territories: American Samoa, Guam, Puerto Rico, the Northern Mariana Islands and the U.S.
            Virgin Islands), Cuba; Democratic People's Republic of North Korea; Islamic Republic of Iran; Syria; the
            Crimea and Sevastopol; the People Republic of China (excluding Hong Kong, Macao and Taiwan); .
          </Typography>
        </ParagraphContainer>
        <ParagraphContainer>
          <Typography type="p">
            This website is experimental and currently in Beta stage. Archimedes does not give any guarantees,
            warranties or representations, express or implied, about the accuracy, reliability, completeness or
            suitability of the information and materials contained in this website for any purpose.
          </Typography>
        </ParagraphContainer>
        <ParagraphContainer>
          <Typography type="p">
            You hereby declare read, understood and agreed to Archimedes Terms of service, Privacy policy, Legal notice
            and Risk Disclosure Statement before using this service
          </Typography>
        </ParagraphContainer>
        <StyledLink target="_blank" href="https://docs.archimedesfi.com/terms-of-service">
          Terms of service
        </StyledLink>
        <StyledLink target="_blank" href="https://docs.archimedesfi.com/privacy-policy">
          Privacy policy
        </StyledLink>
        <StyledLink target="_blank" href="https://docs.archimedesfi.com/risks-disclosure-statement">
          Risk Disclosure Statement
        </StyledLink>
        <StyledLink target="_blank" href="https://docs.archimedesfi.com/legal-notice">
          Legal Notice
        </StyledLink>
      </TextContainer>
      <StyledCheckbox
        checked={checkboxChecked}
        onChange={(checked) => setCheckboxChecked(checked)}
        label="I have read and acknowledge the legal disclaimer."
      />
      <AcceptButton disabled={!checkboxChecked} onClick={handleButtonOnClick}>
        Accept and Close
      </AcceptButton>
    </Container>
  );
};

export default LegalDisclaimerModal;
